import { DatasetBrowserData, PaginationTypes } from '@mode/shared/contract-common';
import {
  DatasetBrowserDataResponse,
  DatasetBrowserDataResponseType,
  DatasetsBrowserDataResponse,
} from './dataset-response.types';

export function mapToDatasetBrowserData(response: DatasetBrowserDataResponseType): DatasetsBrowserDataResponse {
  const datasetBrowserData = response._embedded.reports.map((data: DatasetBrowserDataResponse) => ({
    name: data.name ?? 'Untitled Dataset',
    description: data.description,
    collection: data.collection_name,
    creator: data._embedded.creator.name,
    lastRefreshed: data.last_successfully_run_at,
    datasetToken: data.token,
    switchViewToken: data.switch_view_token,
    isSampleDataset: data.is_sample,
  }));

  const pagination = {
    page: Number(response.pagination_metadata.page),
    per_page: Number(response.pagination_metadata.per_page),
    count: Number(response.pagination_metadata.per_page),
    total_pages: response.pagination_metadata.total_pages,
    total_count: response.pagination_metadata.total_count,
  };

  return { datasetBrowserData, pagination };
}
